module.exports = __webpack_public_path__ + "img/symbol_herzschloss@2x.e8fa179.webp";